import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3CustomizedButton from "../../core/et3-button/Et3CustomizedButton";
import i18n from "../../constants/i18n";
import ET3Circle from "../../core/et3-circle";
import Et3Image from "../../core/et3-Image";

const KhatabaIcon = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  return (
    <Et3CustomizedButton
      isEnabled={true}
      withShadow={false}
      width={180}
      height={95}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Circle
        size={90}
        color={colors.all.transparent}
        style={{
          justifyContent: "center",
          alignItems: "flex-end"
        }}
        withShadow={true}
        onClick={() => {}}
      >
        <Et3Image
          type="LOCAL"
          alt={i18n.get("ALKHATTABA_ADMIN")}
          imageName={"alkhattaba"}
          size={80}
          onClick={() => {}}
          style={{}}
        />
      </ET3Circle>
    </Et3CustomizedButton>
  );
});
export default KhatabaIcon;
